import {useEffect} from 'react';

export function useFlushOnHide(
  getValue: () => number | undefined,
  onFlush: (seconds: number) => void
): void {
  useEffect(() => {
    const flush = () => {
      const v = getValue();
      if (typeof v === 'number' && v > 0) onFlush(v);
    };
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') flush();
    };
    window.addEventListener('pagehide', flush);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('pagehide', flush);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [getValue, onFlush]);
}
